import { createFileRoute } from '@tanstack/react-router'
import SettingsGeneralPage from '@/components/pages/Settings/team/SettingsGeneralPage/SettingsGeneralPage'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/general')({
  component: GeneralSettingsRoute,
})

function GeneralSettingsRoute() {
  return <SettingsGeneralPage />
}
